import * as ActionTypes from 'actions/mdm'

const initialState = {
  isFetching: false,
  fetched: false,
  users: [],
}

export default function mdm(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.MDM_GETING_USERS:
      return Object.assign({}, state, {
        isFetching: true,
      })
    case ActionTypes.MDM_RECEIVED_USERS:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        users: action.users,
      }
    case ActionTypes.MDM_RESET_FETCHED:
      return Object.assign({}, state, {
        fetched: false,
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/mdm.js